import React from "react";
import { Head } from "@inertiajs/react";
import { LandingLanguageProvider } from "../../../contexts/landing-language";
import Header from "./Header";
import Hero from "./Hero";
import BookingWidget from "./BookingWidget";
import About from "./About";
import Facilities from "./Facilities";
import Rooms from "./Rooms";
import Gallery from "./Gallery";
import Footer from "./Footer";
import GuestWidget from "./GuestWidget";

const UnnamedComponent = () => {
  return (
    <LandingLanguageProvider>
      <React.Fragment>
        <Head>
          <title>Hebe Hotel - Eco-Tourism City Experience</title>
          <meta
            name="description"
            content="Book your stay at Hebe Hotel, Hostel & Hospitality Network. Experience sustainable urban travel in the heart of the city."
          />
          <meta
            name="keywords"
            content="Hebe Hotel, Hostel & Hospitality Network, Sustainable Urban Travel, Eco-Tourism, City Experience"
          />
          <meta name="author" content="HostelNMC" />
          <meta name="robots" content="index, follow" />
          <meta
            name="googlebot"
            content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
          />
          <meta name="google" content="notranslate" />
        </Head>

        <Header />
        <Hero />
        <BookingWidget />
        <About />
        <Facilities />
        <Rooms />
        <Gallery />
        <Footer />
        <GuestWidget />
      </React.Fragment>
    </LandingLanguageProvider>
  );
};

export default UnnamedComponent;
